<template>
  <div class="Tree column label">
    <div
      class="noTree row justify-center align-center pointer"
      @click="noTree = !noTree"
    >
      <input type="checkbox" v-model="noTree" /> &nbsp; Não possuo
      {{ modal.text[1] }}.
    </div>
    <template v-if="!noTree">
      <div class="search fa">
        <input
          type="text"
          class="input"
          v-model="search"
          placeholder="Buscar"
        />
      </div>
      <ul class="tag">
        <li
          v-for="(item, i) of filtered"
          :key="'item' + i"
          @click="add(item)"
          title="Adicionar"
        >
          {{ item.nome }}
          <i class="fa fa-plus"></i>
        </li>
      </ul>
      <div class="noItem" v-if="search.length > 2 && filtered.length == 0">
        <br />Não encontrado.
      </div>
      <div class="notFind">
        <br />Não encontrou {{ modal.text[2] }}?
        <a :href="modal.link" target="_blank">Clique aqui.</a>
      </div>

      <div class="divider"></div>
      <div class="tree row column-s">
        <div class="column grid-4 grid-12-s">
          <div class="title">{{ modal.text[0] }}</div>
          <ul class="box">
            <li
              v-for="(node0, name) of modal.list"
              :key="'node-0-' + name"
              @click="addNode(node0)"
            >
              {{ name }}
            </li>
          </ul>
        </div>
        <div class="column grid-4 grid-12-s hide-s">
          <div class="title">{{ modal.text[1] }}</div>
          <ul class="box area">
            <li
              v-for="(item, j) of modal.node1"
              :id="'node-1-' + j"
              class="row"
              :key="'node-1-' + j"
              @click="add(modal.node1[j])"
            >
              <div class="grid">
                {{ item.nome }}
                <i class="fa fa-question-circle font-13 tip">
                  <div>{{ item.descricao }}</div>
                </i>
              </div>
              <strong>
                <i class="fa fa-plus" title="ADICIONAR"></i>
              </strong>
            </li>
          </ul>
        </div>
        <div class="yours column grid-4 grid-12-s">
          <div class="title">{{ modal.text[3] }}</div>
          <div class="box">
            <ul class="tag selected">
              <li
                v-for="(item, i) of this.modal.selected"
                :key="'competencias' + i"
                @click="del(item)"
                title="Excluir Competência"
              >
                {{ item.nome }}
                <i class="fa fa-trash"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>

    <div
      class="save"
      v-if="(modal.selected && modal.selected.length) || noTree"
    >
      <Button layout="green-go" @click="save()" :loader="loader">Salvar</Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
export default {
  name: "Tree",
  props: {
    modal: Object,
    callback: Function,
  },
  components: {
    Button
  },
  data() {
    return {
      search: "",
      noTree: false,
      loader: false,
    };
  },
  methods: {
    save() {
      this.loader = true;
      this.modal.actions
        .save(this.modal.selected)
        .then(() => {
          this.loader = false;
          this.modal.show = false;
          this.callback && this.callback();
        })
        .catch(() => (this.loader = false));
    },
    addNode(node) {
      this.modal.node1 = node;
      this.modal.selected.map((selected) => {
        this.modal.node1 = this.modal.node1.filter(
          (node1) => node1.id !== selected.id
        );
      });
      this.$forceUpdate();
    },
    add(item) {
      this.modal.selected = this.modal.selected.filter(
        (node) => node.id !== item.id
      );
      this.modal.selected.push(item);
      this.modal.node1 = this.modal.node1.filter((node) => node.id !== item.id);
    },
    del(item) {
      this.modal.selected = this.modal.selected.filter(
        (node) => node.id !== item.id
      );
      this.modal.node1.push(item);

      if (
        this.modal.node1.length > 1 &&
        item.id_parent !== this.modal.node1[0].id_parent
      )
        this.modal.node1 = this.modal.node1.filter(
          (node) => node.id !== item.id
        );
    },
  },
  computed: {
    filtered() {
      if (this.search.length > 2) {
        const list = [];
        const search = this.search.toLowerCase();
        for (const key in this.modal.list) {
          if (this.modal.list.hasOwnProperty(key)) {
            this.modal.list[key].map((item) => {
              if (item.nome.toLowerCase().includes(search)) list.push(item);
            });
          }
        }
        return list;
      } else {
        return [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.Tree {
  color: $gray-6;
  padding: 15px;
  .noTree {
    font-size: 14px;
    font-weight: bold;
    color: $gray-4;
    text-transform: uppercase;
    padding: 15px;
    input {
      width: 21px;
      height: 21px;
    }
  }
  .noItem {
    text-align: center;
    margin-bottom: 0.8rem;
    margin-top: 0.7rem;
    a {
      text-decoration: underline;
      color: $supporter-2;
    }
  }
  .notFind {
    text-align: center;
    margin-bottom: 0.8rem;
    margin-top: 0.7rem;
    a {
      text-decoration: underline;
      color: $supporter-2;
    }
  }
  .divider {
    margin-top: 33px;
  }
  .title {
    padding: 20px;
    text-align: center;
    color: $supporter-1;
    font-weight: 500;
  }
  .box {
    @media (min-width: $small) {
      height: 300px;
      overflow-y: auto;
    }
  }
  .tag {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    li {
      border: 1.5px solid $green-4;
      color: $green-4;
      cursor: pointer;
      margin-right: 12px;
      margin-top: 10px;
      border-radius: 100px;
      padding: 5px 10px;
      font-weight: bold;
      &:hover {
        color: $green-2;
        border: 1.5px solid $green-2;
      }
      i {
        margin-left: 5px;
      }
    }
  }
  .selected {
    li:hover {
      background: $white;
      border: 1.5px solid $red !important;
      color: $red !important;
    }
  }
  .search {
    margin-top: 15px;
    input {
      border: none;
      padding: 3px 10px;
      @media (max-width: $small) {
        width: 90%;
      }
    }

    &:after {
      content: "\f002";
      color: $white-4;
      position: absolute;
      margin-left: -35px;
      margin-top: 12px;
      font-size: 23px;
    }
  }
  .save {
    margin-top: 50px;
    text-align: center;
  }
  .tree {
    margin-top: 1.7rem;
    ul.box {
      background: $white;
      border: 1px solid #ddd;
      border-radius: 4px;
      li {
        padding: 15px;

        &:hover {
          color: $blue-2;
          cursor: pointer;
        }
        ul {
          margin-top: 1rem;
          /*     border: 2px solid #ddd; */

          li {
            color: $gray-4;
            font-size: 14px;
            padding: 14px;
            @media (max-width: $small) {
              padding: 25px 20px;
            }
            i {
              font-size: 10px;
            }
          }
        }
      }
    }

    .area {
      @media (min-width: $medium) {
        margin-left: 15px;
      }
      margin-left: 12px;
      background: $white-3;
      li:hover {
        color: $green-2 !important;
      }
      &-hide {
        margin-left: -33%;
      }
      &-mobile {
        background: $white-6;
      }
    }
    .yours {
      @media (min-width: $small) {
        margin-left: 15px;
      }
      @media (max-width: $small) {
        margin-top: 1rem;
      }
    }
    .tag {
      background: $white;
    }
  }
}
</style>
